module.exports = __webpack_public_path__ + "img/mob-query.7dc1611c.svg";